import React, { useEffect, useState } from 'react';
import Layouts from '../layouts/Layouts';
import { DinamicTitle } from '../utils/DinamicTitle';
import { getAuthorizationHeader, http } from '../config/http';
import TambahPengeluaran from './Modal/TambahPengeluaran';
import { IconChevronLeft, IconChevronRight, IconEdit, IconPlus, IconRefresh, IconTrash } from '@tabler/icons-react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { IconCalendarTime } from '@tabler/icons-react';
import { IconArrowsRightLeft } from '@tabler/icons-react';
import ConfirmationProsess from './Modal/ConfirmationProsess';
import LayoutsKasir from '../layouts/LayoutsKasir';
import ModalHapusPengeluaran from './Modal/ModalHapusPengeluaran';
import FilterDrawer, { FilterToggleButton } from '../components/FilterDrawer';


const getTipeLabel = (tipe) => {
  switch (tipe) {
    case 'pemasukan': return 'Pemasukan';
    case 'tambah-kas': return 'Tambah KAS';
    case 'tarik-kas': return 'Tarik KAS';
    case 'm-banking': return 'M-Banking';
    case 'digitalpay-transfer':
    case 'DigitalPay Transfer':
    case 'Digital Pay Transfer':
      return 'Digital Pay Transfer';
    case 'digitalpay-qris':
    case 'DigitalPay QRIS':
    case 'Digital Pay QRIS':
      return 'Digital Pay QRIS';
    case 'digitalpay-edc-debit-kredit':
    case 'digitalpay-edc':
    case 'DigitalPay EDC/DEBIT/KREDIT':
    case 'Digital Pay EDC':
      return 'Digital Pay EDC';
    case 'gaji-karyawan': return 'Gaji Karyawan';
    case 'indihome': return 'Indihome';
    case 'asuransi': return 'Asuransi';
    case 'listrik': return 'Listrik';
    case 'bensin': return 'Bensin';
    case 'parkir': return 'Parkir';
    case 'makan': return 'Makan';
    case 'donasi-santunan': return 'Donasi dan Santunan';
    case 'pengeluaran-lainnya': return 'Pengeluaran Lainnya';
    default: return tipe;
  }
};

function Pengeluaran() {
  DinamicTitle('Pengeluaran || Komaladewi');
  let [isOpenTambahPengeluaran, setIsOpenTambahPengeluaran] = useState(false);
  const navigate = useNavigate();
  function openModalTambahPengeluaran() {
    setFormData({ title: '-', tipe: '', keterangan: '', cabang_id: '' });
    setNominal(0);
    setIsEdit(false);
    setEditId(null);
    setIsOpenTambahPengeluaran(true);
  }

  function closeModalTambahPengeluaran() {
    setIsOpenTambahPengeluaran(false);
    setTimeout(() => {
      setFormData({ title: '-', tipe: '', keterangan: '', cabang_id: '' });
      setNominal(0);
      setIsEdit(false);
      setEditId(null);
    }, 200);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const [pengeluaranHariIni, setPengeluaranHariIni] = useState([]);
  const [loadingPengeluaranHariIni, setLoadingPengeluaranHariIni] = useState(false);
  const [isSubmitPengeluaran, setIsSubmitPengeluaran] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [isOpenModalProses, setIsOpenModalProses] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [submitProsess, setSubmitProsess] = useState(false);

  // Filter drawer & row selection state
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const [cabang, setCabang] = useState([]);

  useEffect(() => {
    async function getCabang() {
      await http
        .get('/cabang', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          }
        });
    }
    getCabang();
  }, []);
  const [isProses, setIsProses] = useState(0);
  const [cabangId, setCabangId] = useState('');
  async function getPengeluaranHariIni() {
    setLoadingPengeluaranHariIni(true);
    await http
      .get(
        `cashflow?page=${currentPage}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${cabangId === '' ? '' : `&cabang=${cabangId}`}${isProses === '' ? '' : `&is_proses=${isProses}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setLastPage(res.data.data.last_page);
        setCurrentPage(res.data.data.current_page);
        setPengeluaranHariIni(res.data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingPengeluaranHariIni(false);
  }
  useEffect(() => {
    getPengeluaranHariIni();
  }, [isSubmitPengeluaran, currentPage, awal, akhir, isProses, cabangId, submitProsess]);

  // Selection helpers (only unprocessed rows can be processed)
  const isRowSelectable = (phi) => phi.is_proses === 0;
  const selectableItems = pengeluaranHariIni.filter(isRowSelectable);
  const isAllSelectableSelected =
    selectableItems.length > 0 &&
    selectableItems.every((item) => selectedIds.includes(item.id));

  const handleToggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleToggleSelectAll = () => {
    if (isAllSelectableSelected) {
      const selectableIds = selectableItems.map((item) => item.id);
      setSelectedIds((prev) => prev.filter((id) => !selectableIds.includes(id)));
    } else {
      const selectableIds = selectableItems.map((item) => item.id);
      setSelectedIds((prev) => Array.from(new Set([...prev, ...selectableIds])));
    }
  };

  // Active filter count (Etalase, Status, Tanggal)
  const activeFilterCount = [
    Boolean(startDate && endDate),
    Boolean(cabangId),
    isProses !== '' && isProses !== 0,
  ].filter(Boolean).length;

  // Refresh data via REST API request
  const handleRefresh = async () => {
    await getPengeluaranHariIni();
    toast.info('Data berhasil dimuat ulang', { autoClose: 600 });
  };

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setCabangId('');
    setIsProses(0);
    setCurrentPage(1);
    setSelectedIds([]);
  };

  const [formData, setFormData] = useState({
    title: '-',
    tipe: '',
    keterangan: '',
    cabang_id: '',
  });
  const [nominal, setNominal] = useState(0);

  function handleOnChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  async function handleSubmitPengeluaran(e) {
    e.preventDefault();
    if (!formData.tipe) {
      toast.warning('Pilih tipe transaksi terlebih dahulu', { autoClose: 600 });
      return;
    }
    if (!nominal || Number(nominal) <= 0) {
      toast.warning('Masukkan nominal pengeluaran', { autoClose: 600 });
      return;
    }
    setLoadingSubmit(true);
    const resolvedTitle = (formData.title && formData.title !== '-') ? formData.title : (getTipeLabel(formData.tipe) || '-');
    const data = {
      title: resolvedTitle,
      tipe: formData.tipe,
      cabang_id: formData.cabang_id,
      nominal,
      keterangan: formData.keterangan || '',
    };
    try {
      const response = await http.post(`/cashflow`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message, { autoClose: 600 });
      closeModalTambahPengeluaran();
      getPengeluaranHariIni();
      setIsSubmitPengeluaran((prev) => !prev);
      setLoadingSubmit(false);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/login');
      } else if (error.response?.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600 });
      } else if (error.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600 });
      }
      setLoadingSubmit(false);
    }
  }
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  async function getDetailPengeluaran(id) {
    setLoading(true);
    await http.get(`/cashflow/${id}`, {
      headers: { Authorization: getAuthorizationHeader() },
    }).then((res) => {
      const data = res.data.data;
      setFormData({
        title: data.title || '-',
        tipe: data.tipe || '',
        keterangan: data.keterangan || '',
        cabang_id: data.cabang_id || '',
      });
      setNominal(data.nominal || 0);
      setEditId(id);
      setIsEdit(true);
      setIsOpenTambahPengeluaran(true);
    }).catch((error) => {
      console.log(`error : ${error}`);
    })
    setLoading(false);
  }

  async function handleEditPengeluaran(e) {
    e.preventDefault();
    if (!formData.tipe) {
      toast.warning('Pilih tipe transaksi terlebih dahulu', { autoClose: 600 });
      return;
    }
    if (!nominal || Number(nominal) <= 0) {
      toast.warning('Masukkan nominal pengeluaran', { autoClose: 600 });
      return;
    }
    setLoadingSubmit(true);
    const resolvedTitle = (formData.title && formData.title !== '-') ? formData.title : (getTipeLabel(formData.tipe) || '-');
    const data = {
      title: resolvedTitle,
      tipe: formData.tipe,
      cabang_id: formData.cabang_id,
      nominal,
      keterangan: formData.keterangan || '',
    };
    try {
      const response = await http.put(`/cashflow/${editId}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success('Data berhasil diupdate', { autoClose: 600 });
      closeModalTambahPengeluaran();
      getPengeluaranHariIni();
      setIsSubmitPengeluaran((prev) => !prev);
      setLoadingSubmit(false);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/login');
      } else if (error.response?.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600 });
      } else if (error.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600 });
      } else if (error.status === 404) {
        toast.error(error.response?.data?.message, { autoClose: 600 });
      }
      setLoadingSubmit(false);
    }
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };
  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    setCurrentPage(1);
    setSelectedIds([]);
  }

  function handleOpenModalProses() {
    if (selectedIds.length === 0) {
      toast.warning('Pilih data yang akan diproses terlebih dahulu', { autoClose: 1200 });
      return;
    }
    openModalProses();
  }

  async function submitProses(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (selectedIds.length === 0) {
      toast.warning('Pilih data yang akan diproses terlebih dahulu', { autoClose: 1000 });
      return;
    }
    setIsLoadingSubmit(true);
    const payload = {
      items: selectedIds,
      ids: selectedIds,
      cashflow_ids: selectedIds,
    };
    try {
      const res = await http.post(`submit_cashflow`, payload, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      closeModalProses();
      toast.success(res.data?.message || 'Data berhasil diproses', { autoClose: 600 });
      setSelectedIds([]);
      setSubmitProsess(true);
      await getPengeluaranHariIni();
      setTimeout(() => {
        setSubmitProsess(false);
      }, 2000);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 404) {
        toast.warning('Tidak ada data', { autoClose: 600 });
      } else if (err.response?.status === 401) {
        toast.warning(err.response?.data?.message || 'Unauthorized', { autoClose: 600 });
      } else {
        toast.error(err.response?.data?.message || 'Gagal memproses data', { autoClose: 1000 });
      }
    } finally {
      setIsLoadingSubmit(false);
    }
  }

  function closeModalProses() {
    setIsOpenModalProses(false);
  }
  function openModalProses() {
    setIsOpenModalProses(true);
  }
  const [isOpenModalHapus, setIsOpenModalHapus] = useState(false);
  const [idHapus, setIdHapus] = useState(null);
  function closeModalHapus() {
    setIsOpenModalHapus(false);
  }
  function openModalHapus(id) {
    setIsOpenModalHapus(true);
    setIdHapus(id);
  }

  // ─── Shared Loading Overlay ───
  const LoadingOverlay = () => (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
      <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
    </div>
  );

  // ─── Filter Drawer Component (muncul dari kanan layar) ───
  const filterDrawerElement = (
    <FilterDrawer
      isOpen={isFilterOpen}
      onClose={() => setIsFilterOpen(false)}
      title="Filter Pengeluaran & Pemasukan"
      subtitle="Filter data kas"
      activeFilterCount={activeFilterCount}
      onReset={handleResetFilter}
    >
      {/* Etalase */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-slate-700 dark:text-slate-300">
          Etalase
        </label>
        <select
          value={cabangId}
          onChange={(e) => {
            setCabangId(e.target.value);
            setCurrentPage(1);
            setSelectedIds([]);
          }}
          className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
        >
          <option value="">Semua Etalase</option>
          {cabang.map((cb) => (
            <option key={cb.id} value={cb.id}>
              {cb.nama_cabang}
            </option>
          ))}
        </select>
      </div>

      {/* Status */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-slate-700 dark:text-slate-300">
          Status
        </label>
        <select
          value={isProses}
          onChange={(e) => {
            setIsProses(e.target.value);
            setCurrentPage(1);
            setSelectedIds([]);
          }}
          className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
        >
          <option value="">Semua Status</option>
          <option value={0}>Belum diproses</option>
          <option value={1}>Sudah diproses</option>
        </select>
      </div>

      {/* Tanggal */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-slate-700 dark:text-slate-300">
          Tanggal
        </label>
        <div className="dropdown dropdown-bottom w-full">
          <div
            tabIndex={0}
            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs"
            title="Pilih Tanggal"
          >
            <div className="flex items-center gap-2 truncate">
              <IconCalendarTime size={16} className="text-amber-500 shrink-0" />
              <span className="truncate">
                {startDate && endDate
                  ? awal === akhir
                    ? awal
                    : `${awal} - ${akhir}`
                  : 'Pilih Rentang Tanggal'}
              </span>
            </div>
          </div>
          <div
            tabIndex={0}
            className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[99999] mt-1 right-0 max-w-[92vw] overflow-x-auto"
          >
            <DateRange ranges={[selectionRange]} onChange={handleSelect} />
            {startDate && (
              <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                <button
                  type="button"
                  onClick={() => {
                    setStartDate(null);
                    setEndDate(null);
                    setCurrentPage(1);
                    setSelectedIds([]);
                  }}
                  className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                >
                  Reset Tanggal
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </FilterDrawer>
  );

  // ─── Shared Toolbar ───
  const Toolbar = () => (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-3 py-3 sm:px-4 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700/60">
      <div className="flex items-center gap-2 flex-wrap">
        <FilterToggleButton
          onClick={() => setIsFilterOpen(true)}
          isOpen={isFilterOpen}
          activeFilterCount={activeFilterCount}
        />
        <button
          type="button"
          onClick={handleRefresh}
          disabled={loadingPengeluaranHariIni}
          className="flex items-center justify-center p-2 rounded-lg text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 hover:border-amber-400 dark:hover:border-amber-500 hover:text-amber-600 dark:hover:text-amber-400 transition shadow-xs cursor-pointer disabled:opacity-50"
          title="Muat Ulang Data (Rest Request)"
        >
          <IconRefresh size={18} className={loadingPengeluaranHariIni ? 'animate-spin text-amber-500' : ''} />
        </button>

        {selectedIds.length > 0 && (
          <div className="flex items-center gap-2 px-2.5 py-1.5 bg-amber-50 dark:bg-amber-950/40 border border-amber-300 dark:border-amber-700/60 rounded-lg text-xs">
            <span className="font-semibold text-amber-800 dark:text-amber-300">
              {selectedIds.length} data dipilih
            </span>
            <button
              type="button"
              onClick={() => setSelectedIds([])}
              className="text-xs text-rose-500 hover:text-rose-700 font-bold ml-1 cursor-pointer"
              title="Batalkan Pilihan"
            >
              Batal
            </button>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button
          type="button"
          className="flex items-center gap-1.5 px-3 py-2 text-sm font-semibold bg-amber-500 hover:bg-amber-600 text-white rounded-md transition shadow-xs cursor-pointer"
          onClick={handleOpenModalProses}
        >
          <IconArrowsRightLeft size={16} />
          <span>Proses{selectedIds.length > 0 ? ` (${selectedIds.length})` : ''}</span>
        </button>
        <ConfirmationProsess
          submitProses={submitProses}
          closeModaProses={closeModalProses}
          isOpenModalProses={isOpenModalProses}
          isLoadingSubmit={isLoadingSubmit}
          selectedCount={selectedIds.length}
        />
        <button
          type="button"
          className="flex items-center gap-1.5 px-3 py-2 text-sm font-semibold bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white rounded-md shadow-sm transition-all cursor-pointer"
          onClick={openModalTambahPengeluaran}
        >
          <IconPlus size={16} />
          Tambah
        </button>
      </div>
    </div>
  );

  // ─── Shared Loading Content ───
  const LoadingContent = () => (
    <div className="flex items-center justify-center py-12">
      <div className="flex items-center gap-3 text-sm text-slate-500 dark:text-slate-400">
        <div className="w-5 h-5 rounded-full animate-spin border-2 border-dashed border-amber-500 border-t-transparent"></div>
        Memuat data...
      </div>
    </div>
  );

  // ─── Shared Pagination ───
  const Pagination = () => (
    <div className="flex items-center justify-between px-3 py-3 sm:px-4 border-t border-slate-200 dark:border-slate-700/60 bg-slate-50 dark:bg-slate-800/50">
      <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400">
        Halaman <span className="font-semibold text-slate-700 dark:text-slate-300">{currentPage}</span> dari <span className="font-semibold text-slate-700 dark:text-slate-300">{lastPage}</span>
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <IconChevronLeft size={16} />
        </button>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === lastPage}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <IconChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  // ─── Table Header Cell ───
  const Th = ({ children }) => (
    <th className="px-3 sm:px-4 py-2.5 text-left text-[10px] sm:text-xs font-semibold text-amber-800 dark:text-amber-500 uppercase tracking-wider whitespace-nowrap bg-amber-50/80 dark:bg-slate-800/80">
      {children}
    </th>
  );

  // ─── Table Data Cell ───
  const Td = ({ children, className = '' }) => (
    <td className={`px-3 sm:px-4 py-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-300 whitespace-nowrap border-b border-slate-100 dark:border-slate-700/50 ${className}`}>
      {children}
    </td>
  );

  const role = localStorage.getItem('role');
  if (role === 'kasir') {
    return (
      <LayoutsKasir compFilter={null}>
        <div className="sm:mx-3 sm:my-2">
          {filterDrawerElement}
          {loading && <LoadingOverlay />}
          <TambahPengeluaran
            cabang={cabang}
            handleSubmitPengeluaran={handleSubmitPengeluaran}
            handleEditPengeluaran={handleEditPengeluaran}
            isEdit={isEdit}
            formData={formData}
            loadingSubmit={loadingSubmit}
            nominal={nominal}
            setNominal={setNominal}
            handleOnChange={handleOnChange}
            closeModalTambahPengeluaran={closeModalTambahPengeluaran}
            isOpenTambahPengeluaran={isOpenTambahPengeluaran}
          />
          <div className="bg-white dark:bg-slate-900 shadow-sm border-t sm:border sm:rounded-md border-slate-200 dark:border-slate-700/60 overflow-hidden">
            <Toolbar />
            {loadingPengeluaranHariIni ? (
              <LoadingContent />
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b border-slate-200 dark:border-slate-700/60">
                      <Th>
                        <div className="flex items-center justify-center">
                          <input
                            type="checkbox"
                            className="checkbox checkbox-xs checkbox-warning rounded cursor-pointer"
                            checked={isAllSelectableSelected}
                            onChange={handleToggleSelectAll}
                            disabled={selectableItems.length === 0}
                            title={
                              selectableItems.length === 0
                                ? 'Tidak ada data yang dapat diproses'
                                : isAllSelectableSelected
                                ? 'Batalkan semua pilihan'
                                : 'Pilih semua yang belum diproses'
                            }
                          />
                        </div>
                      </Th>
                      <Th>No</Th>
                      <Th>Title</Th>
                      <Th>Nominal</Th>
                      {/* <Th>Keterangan</Th> */}
                      <Th>Tanggal</Th>
                      <Th>Diproses</Th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {pengeluaranHariIni.map((phi, i) => {
                      const isSelected = selectedIds.includes(phi.id);
                      const canSelect = phi.is_proses === 0;
                      return (
                        <tr
                          key={phi.id}
                          className={`hover:bg-amber-50/40 dark:hover:bg-slate-800/50 transition-colors ${
                            isSelected ? 'bg-amber-50/70 dark:bg-amber-950/30' : 'bg-white dark:bg-slate-900'
                          }`}
                        >
                          <Td className="w-10 text-center">
                            <div className="flex items-center justify-center">
                              {canSelect ? (
                                <input
                                  type="checkbox"
                                  className="checkbox checkbox-xs checkbox-warning rounded cursor-pointer"
                                  checked={isSelected}
                                  onChange={() => handleToggleSelect(phi.id)}
                                />
                              ) : (
                                <input
                                  type="checkbox"
                                  className="checkbox checkbox-xs rounded opacity-30 cursor-not-allowed"
                                  disabled
                                  checked={false}
                                  title="Sudah diproses"
                                />
                              )}
                            </div>
                          </Td>
                          <Td>{(currentPage - 1) * 10 + i + 1}.</Td>
                          <Td>
                            <span className="font-medium text-slate-800 dark:text-slate-200">{getTipeLabel(phi.tipe)}</span><br />
                            <span className="text-xs text-slate-500 dark:text-slate-400">
                              {(phi.keterangan === '' || phi.keterangan === '.' || phi.keterangan === '-') ? '' : `(${phi.keterangan})`}
                            </span>
                          </Td>
                          <Td><span className="font-semibold text-slate-900 dark:text-slate-100">Rp {numberWithCommas(phi.nominal)}</span></Td>
                          {/* <Td>{phi.keterangan || <span className="text-slate-400 dark:text-slate-600">—</span>}</Td> */}
                          <Td>{phi.created_at}</Td>
                          <Td>
                            {phi.is_proses === 0 ? (
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400">Belum</span>
                            ) : (
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400">Proses</span>
                            )}
                          </Td>
                        </tr>
                      );
                    })}
                    {pengeluaranHariIni.length === 0 && (
                      <tr className="bg-white dark:bg-slate-900">
                        <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-400 dark:text-slate-500">Tidak ada data pengeluaran.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <Pagination />
          </div>
        </div>
      </LayoutsKasir>
    );
  } else {
    return (
      <Layouts
        title={'Pengeluaran dan Pemasukan KAS'}
        compFilter={null}
      >
        {filterDrawerElement}
        {loading && <LoadingOverlay />}
        <ModalHapusPengeluaran
          idHapus={idHapus}
          closeModaLogout={closeModalHapus}
          isOpenModalLogout={isOpenModalHapus}
          getPengeluaranHariIni={getPengeluaranHariIni}
        />
        <div className="sm:mx-3 sm:my-2">
          <TambahPengeluaran
            cabang={cabang}
            handleSubmitPengeluaran={handleSubmitPengeluaran}
            handleEditPengeluaran={handleEditPengeluaran}
            isEdit={isEdit}
            formData={formData}
            loadingSubmit={loadingSubmit}
            nominal={nominal}
            setNominal={setNominal}
            handleOnChange={handleOnChange}
            closeModalTambahPengeluaran={closeModalTambahPengeluaran}
            isOpenTambahPengeluaran={isOpenTambahPengeluaran}
          />
          <div className="bg-white dark:bg-slate-900 shadow-sm border-t sm:border sm:rounded-md border-slate-200 dark:border-slate-700/60 overflow-hidden">
            <Toolbar />
            {loadingPengeluaranHariIni ? (
              <LoadingContent />
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b border-slate-200 dark:border-slate-700/60">
                      <Th>
                        <div className="flex items-center justify-center">
                          <input
                            type="checkbox"
                            className="checkbox checkbox-xs checkbox-warning rounded cursor-pointer"
                            checked={isAllSelectableSelected}
                            onChange={handleToggleSelectAll}
                            disabled={selectableItems.length === 0}
                            title={
                              selectableItems.length === 0
                                ? 'Tidak ada data yang dapat diproses'
                                : isAllSelectableSelected
                                ? 'Batalkan semua pilihan'
                                : 'Pilih semua yang belum diproses'
                            }
                          />
                        </div>
                      </Th>
                      <Th>No</Th>
                      <Th>Title</Th>
                      <Th>Nominal</Th>
                      {/* <Th>Keterangan</Th> */}
                      <Th>Tanggal</Th>
                      <Th>Aksi</Th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {pengeluaranHariIni.map((phi, i) => {
                      const isSelected = selectedIds.includes(phi.id);
                      const canSelect = phi.is_proses === 0;
                      return (
                        <tr
                          key={phi.id}
                          className={`hover:bg-amber-50/40 dark:hover:bg-slate-800/50 transition-colors ${
                            isSelected ? 'bg-amber-50/70 dark:bg-amber-950/30' : 'bg-white dark:bg-slate-900'
                          }`}
                        >
                          <Td className="w-10 text-center">
                            <div className="flex items-center justify-center">
                              {canSelect ? (
                                <input
                                  type="checkbox"
                                  className="checkbox checkbox-xs checkbox-warning rounded cursor-pointer"
                                  checked={isSelected}
                                  onChange={() => handleToggleSelect(phi.id)}
                                />
                              ) : (
                                <input
                                  type="checkbox"
                                  className="checkbox checkbox-xs rounded opacity-30 cursor-not-allowed"
                                  disabled
                                  checked={false}
                                  title="Sudah diproses"
                                />
                              )}
                            </div>
                          </Td>
                          <Td>{(currentPage - 1) * 10 + i + 1}.</Td>
                          <Td>
                            <span className="font-medium text-slate-800 dark:text-slate-200">{getTipeLabel(phi.tipe)}</span><br />
                            <span className="text-xs text-slate-500 dark:text-slate-400">
                              {(phi.keterangan === '' || phi.keterangan === '.' || phi.keterangan === '-' || phi.keterangan === null) ? '' : `(${phi.keterangan})`}
                            </span>
                          </Td>
                          <Td><span className="font-semibold text-slate-900 dark:text-slate-100">Rp {numberWithCommas(phi.nominal)}</span></Td>
                          {/* <Td>{phi.keterangan || <span className="text-slate-400 dark:text-slate-600">—</span>}</Td> */}
                          <Td>{phi.created_at}</Td>
                          <Td>
                            {phi.is_proses === 0 ? (
                              <div className="flex items-center gap-1.5">
                                <button
                                  onClick={() => getDetailPengeluaran(phi.id)}
                                  className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-amber-100 dark:bg-amber-900/40 hover:bg-amber-200 dark:hover:bg-amber-900/60 text-amber-700 dark:text-amber-400 transition"
                                  title="Edit"
                                >
                                  <IconEdit className="w-4 h-4" />
                                </button>
                                <button
                                  onClick={() => openModalHapus(phi.id)}
                                  className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-red-100 dark:bg-red-900/30 hover:bg-red-200 dark:hover:bg-red-900/50 text-red-600 dark:text-red-400 transition"
                                  title="Hapus"
                                >
                                  <IconTrash className="w-4 h-4" />
                                </button>
                              </div>
                            ) : (
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400">
                                Telah diproses
                              </span>
                            )}
                          </Td>
                        </tr>
                      );
                    })}
                    {pengeluaranHariIni.length === 0 && (
                      <tr className="bg-white dark:bg-slate-900">
                        <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-400 dark:text-slate-500">Tidak ada data pengeluaran.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <Pagination />
          </div>
        </div>
      </Layouts>
    );
  }
}

export default Pengeluaran;
